import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { Spin } from 'platform-components';
import { coursePropType, isNodeInViewport } from 'platform-components/utils';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import Lessons from 'common.components/lessons/lessons';
import { loadingStatusPropType } from 'utils/data-prop-types';

import { LOADING_BREAKPOINT_INDEX } from './lesson-loader.constants';

/*
 * Компонент рассчитывает, что выбранный курс уже загружен в стор
 * TODO: подумать. Возможно при появлении ручек для табов окажется, что лучше lesson-loader все будет делать сам.
 *  Тогда ему нужно передавать только ручку загрузки и id курса
 */
export class LessonLoader extends React.Component {
    static propTypes = {
        checkShouldDisableLesson: PropTypes.func,
        canEditLessons: PropTypes.bool,
        compactView: PropTypes.bool,
        courseId: PropTypes.number.isRequired,
        course: coursePropType,
        lessons: PropTypes.array.isRequired,
        lessonsMix: PropTypes.string,
        loadingStatus: loadingStatusPropType.isRequired,
        onLessonClick: PropTypes.func,
        onSettingsClick: PropTypes.func,
        shouldLoadLessons: PropTypes.bool.isRequired,
        getNextPageRequest: PropTypes.func.isRequired,
        shouldRenderEmptyMessage: PropTypes.bool,
        onShowMore: PropTypes.func,
        subscriptions: PropTypes.object,
        shouldShowLikes: PropTypes.bool,
        clessonLikes: PropTypes.object,
    };

    componentDidMount() {
        window.addEventListener('scroll', this.tryLoadNextLessonsPage, { passive: true });
        window.addEventListener('resize', this.tryLoadNextLessonsPage, { passive: true });
        this.tryLoadNextLessonsPage();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.reInitScroll(nextProps);
    }

    componentDidUpdate() {
        this.tryLoadNextLessonsPage();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.tryLoadNextLessonsPage, { passive: true });
        window.removeEventListener('resize', this.tryLoadNextLessonsPage, { passive: true });
    }

    tryLoadNextLessonsPage = () => {
        const isScrolledIntoView = isNodeInViewport(this.breakpointLesson);
        const { compactView, courseId, getNextPageRequest, shouldLoadLessons } = this.props;

        const shouldCallRequest =
            !compactView &&
            courseId &&
            // если breakpoint существует, то проверяем его видимость на экране
            // иначе - видимость не важна
            (isScrolledIntoView || !this.breakpointLesson) &&
            shouldLoadLessons;

        if (shouldCallRequest) {
            getNextPageRequest();
        }
    };

    reInitScroll = (nextProps) => {
        // TODO: отпилить пагинацию
        const { shouldLoadLessons } = nextProps;
        const { shouldLoadLessons: prevShouldLoadLessons } = this.props;

        // больше нечего грузить - выключаем события на скролле
        if (!shouldLoadLessons && prevShouldLoadLessons) {
            window.removeEventListener('scroll', this.tryLoadNextLessonsPage, { passive: true });
            window.removeEventListener('resize', this.tryLoadNextLessonsPage, { passive: true });
        }

        // появилась возможность грузить - включаем события на скролле
        if (shouldLoadLessons && !prevShouldLoadLessons) {
            window.addEventListener('scroll', this.tryLoadNextLessonsPage, { passive: true });
            window.addEventListener('resize', this.tryLoadNextLessonsPage, { passive: true });
        }
    };

    setBreakpointLessonRef = (ref, index) => {
        const { lessons } = this.props;

        if (!ref || !lessons) {
            return;
        }

        const lastLessonIndex = lessons.length - 1;

        if (index === lastLessonIndex - LOADING_BREAKPOINT_INDEX) {
            this.breakpointLesson = ref ? ReactDOM.findDOMNode(ref) : null;
        }
    };

    render() {
        const {
            canEditLessons,
            checkShouldDisableLesson,
            compactView,
            courseId,
            course,
            lessons,
            lessonsMix,
            loadingStatus,
            shouldRenderEmptyMessage,
            onShowMore,
            onLessonClick,
            onSettingsClick,
            subscriptions,
            shouldShowLikes,
            clessonLikes,
        } = this.props;

        // TODO: выяснить почему падает без !lessons
        if (!lessons || lessons.length === 0) {
            if (loadingStatus === LOADING_STATUSES.LOADING) {
                return (
                    <div className="course-view__lessons-spin">
                        <Spin center />
                    </div>
                );
            }

            return null;
        }

        return (
            <React.Fragment>
                <Lessons
                    checkShouldDisableLesson={checkShouldDisableLesson}
                    clessonLikes={clessonLikes}
                    compactView={compactView}
                    course={course}
                    courseId={courseId}
                    lessons={lessons}
                    mix={lessonsMix}
                    onLessonClick={onLessonClick}
                    onSettingsClick={onSettingsClick}
                    onShowMore={onShowMore}
                    setLessonRef={this.setBreakpointLessonRef}
                    shouldRenderEmptyMessage={shouldRenderEmptyMessage}
                    shouldShowLikes={shouldShowLikes}
                    shouldShowSettings={canEditLessons}
                    subscriptions={subscriptions}
                />
                {loadingStatus === LOADING_STATUSES.LOADING && (
                    <div className="course-view__lessons-spin">
                        <Spin center />
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default LessonLoader;
